'use strict';

/*
 * LS-2925 sticky desktop header
 */
var fn, hasStickyHeader, header, inExperiment, lastY, offset, onScroll, removeEventListener, removeStickyClass, rtChannel, setEventListener, shouldApply, stickyClass, stickyHeader, tick;

header = void 0;

fn = void 0;

lastY = 0;

offset = 0;

tick = false;

stickyClass = '';

hasStickyHeader = false;

inExperiment = false;


/*
 * Bind sticky header method from scroll event
 * Remove mouse enter event
 * NOTE: function is used externally
 */

setEventListener = function() {
  if (!hasStickyHeader) {
    return;
  }
  window.addEventListener('scroll', rtChannel, {
    passive: true
  });
  if (!header) {
    return;
  }
  header.addEventListener('mouseenter', removeStickyClass, {
    passive: true
  });
};


/*
 * Remove sticky header method to scroll event
 * Add event to show the channel nav, when mouse enters header
 * NOTE: function is used externally
 */

removeEventListener = function() {
  if (!hasStickyHeader) {
    return;
  }
  window.removeEventListener('scroll', rtChannel, {
    passive: true
  });
  if (!header) {
    return;
  }
  header.removeEventListener('mouseenter', removeStickyClass, {
    passive: true
  });
  header.classList.remove(stickyClass);
};


/**
 * Callback to remove sticky class
 *
 * @callback removeStickyClass
 */

removeStickyClass = function() {
  this.classList.remove(stickyClass);
};


/**
 * Scroll callback
 *
 * @callback rtChannel
 */

rtChannel = function() {
  if (!tick) {
    fn(onScroll);
  }
  tick = true;
};


/**
 * Callback animating the header elements
 *
 * @callback onScroll
 */

onScroll = function() {
  var y;
  y = window.scrollY || window.pageYOffset;
  if (lastY < y && y > offset) {
    header.classList.add(stickyClass);
  } else if (lastY > y || y < offset) {
    header.classList.remove(stickyClass);
  }
  lastY = y;
  tick = false;
};


/**
 * Test if sticky header should be applied
 *
 * @returns {Boolean}
 */

shouldApply = function() {
  var $header;
  if (!inExperiment) {
    return false;
  }
  if (!($header = $('.header-v2')).length) {
    return false;
  }
  if (!$header.hasClass('ls-sticky-header')) {
    return false;
  }
  return true;
};

stickyHeader = {

  /**
   * @param {String} [mode] - Sticky header mode - determines how the header behaves. (Optional)
   */
  init: function(mode) {
    var ref, ref1;
    if (mode == null) {
      mode = 'search';
    }
    if ((ref = Groupon.LS) != null ? (ref1 = ref.flags) != null ? ref1.isSearchPage : void 0 : void 0) {
      if (typeof Finch !== "undefined" && Finch !== null) {
        Finch.experiment("LS-2925-StickySearchBar", {
          Control: function() {},
          Treatment: function() {
            inExperiment = true;
            return $('.header-v2').addClass('ls-sticky-header');
          }
        });
      }
    }
    if (!(hasStickyHeader = shouldApply())) {
      return;
    }
    header = $('.header-v2')[0];
    switch (mode) {
      case 'search':
        stickyClass = 'ls-sticky-search';
        break;
      default:
        stickyClass = 'ls-sticky-channel';
    }
    fn = function(cb) {
      return window.requestAnimationFrame(cb);
    };
    lastY = window.scrollY || window.pageYOffset;
    offset += 1;
    setEventListener();
  },
  pause: function() {
    return removeEventListener();
  },
  resume: function() {
    return setEventListener();
  }
};

module.exports = stickyHeader;

